import { ConsentResource, consentResource } from '@witkac/kartamiejska-resources';
import { Consent } from '@witkac/kartamiejska-shared';

import { EntityModule } from './entity.module';

/**
 * Modół zgód
 *
 * @export
 * @class ConsentModule
 * @extends {EntityModule<Consent, ConsentResource>}
 */
export class ConsentModule extends EntityModule<Consent, ConsentResource> {
  constructor() {
    super(consentResource);
  }
}

export default new ConsentModule();
